import { Card, Colors, Heading, Icon, Pills, Text } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';
import { useCompanyInformation } from '@/hooks/company/useCompanyInformation';

export interface StartReviewHeaderProps {
    className?: string;
    isSelfEvaluation: boolean | undefined;
}

export const StartReviewHeader = ({ className = '', isSelfEvaluation }: StartReviewHeaderProps) => {
    const { t } = useAmelioTranslations();
    const { getManagerLabel } = useCompanyInformation();
    const cardClasses = `relative rounded-2xl bg-primary-50 p-8 px-8 ${className}`;

    return (
        <Card className={cardClasses}>
            <div className={'absolute -top-3 -left-7'}>
                <Pills
                    variant={'purple'}
                    size={'sm'}
                >
                    {isSelfEvaluation
                        ? t('startReview.selfEvaluationHeader.pillLabel')
                        : t('startReview.header.pillLabel')}
                </Pills>
            </div>

            {/* Content */}
            <div className={'flex items-center gap-6'}>
                {/* Icon */}
                <div
                    className={
                        'bg-primary-50 flex aspect-square h-16 w-16 shrink-0 items-center justify-center rounded-full'
                    }
                >
                    <Icon
                        name={'arrow-refresh-2'}
                        size={32}
                        color={Colors.PRIMARY}
                        aria-hidden
                    />
                </div>

                {/* Text */}
                <div>
                    <Heading level={4}>
                        {isSelfEvaluation
                            ? t('startReview.selfEvaluationHeader.title')
                            : t('startReview.header.title')}
                    </Heading>

                    <Text
                        size={'small'}
                        className={'mt-1'}
                        color={Colors.BASE_600}
                    >
                        {isSelfEvaluation
                            ? t('startReview.selfEvaluationHeader.description', {
                                  managerLabel: getManagerLabel(),
                              })
                            : t('startReview.header.description')}
                    </Text>
                </div>
            </div>
        </Card>
    );
};
